/* ═════ TIENDA DORADA · comportamiento de la barra de filtros ═════
   Compartido por colección y búsqueda. Se llama pasándole la raíz de la sección. */
window.tdFiltros = function (raiz) {
  if (!raiz || raiz.dataset.tdListo) return;
  raiz.dataset.tdListo = '1';

  var form = raiz.querySelector('[data-td-form]');
  var barra = raiz.querySelector('[data-td-barra]');
  var centinela = raiz.querySelector('[data-td-centinela]');

  // La sombra solo aparece cuando la barra se ha quedado pegada arriba.
  if (barra && centinela && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) {
      barra.classList.toggle('td-fijo', !e[0].isIntersecting);
    }, { threshold: 0 }).observe(centinela);
  }

  function cerrarTodos() {
    raiz.querySelectorAll('[data-td-chip]').forEach(function (c) {
      c.classList.remove('td-op');
      var b = c.querySelector('[data-td-abrir]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  raiz.querySelectorAll('[data-td-chip]').forEach(function (chip) {
    var boton = chip.querySelector('[data-td-abrir]');
    if (!boton) return;
    boton.addEventListener('click', function (e) {
      e.stopPropagation();
      var abierto = chip.classList.contains('td-op');
      cerrarTodos();
      if (!abierto) {
        chip.classList.add('td-op');
        boton.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-td-chip]')) cerrarTodos();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrarTodos();
  });

  if (!form) return;

  // Los campos vacíos y el orden por defecto se desactivan antes de enviar,
  // así no ensucian la URL con parámetros que no filtran nada.
  function limpiar() {
    form.querySelectorAll('input[type=number]').forEach(function (el) {
      if (el.value.trim() === '') el.disabled = true;
    });
    var sel = form.querySelector('select[name=sort_by]');
    if (sel && sel.value === sel.getAttribute('data-td-defecto')) sel.disabled = true;
  }

  function enviar() { limpiar(); form.submit(); }

  form.addEventListener('submit', limpiar);
  form.addEventListener('change', function (e) {
    if (e.target.type === 'number') return;
    enviar();
  });
  form.querySelectorAll('input[type=number]').forEach(function (inp) {
    inp.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); enviar(); }
    });
    inp.addEventListener('blur', function () {
      if (inp.value !== inp.defaultValue) enviar();
    });
  });
};
